.GetStartedImg {
  max-width: 470px;
}
